
import { CanActivateFn, Router } from "@angular/router";
import { GlobalValues } from '@app/_services/global-values';
import { inject } from '@angular/core';


export const filesGuard: CanActivateFn = async () => {
    const globalService = inject(GlobalValues);
    const router = inject(Router);

    if (globalService.userEmailId) {
        const nibEmailDomain = 'nibaustralia.com.au';
        const mk3EmailDomain = 'mk3.com.au';
        if (globalService.userEmailId.toLowerCase().endsWith(`@${nibEmailDomain.toLowerCase()}`) ||
            globalService.userEmailId.toLowerCase().endsWith(`@${mk3EmailDomain.toLowerCase()}`)) {
            return true;
        }
    }
    router.navigate(['/']);
    return false;
};